<template>
  <section class="question-block" v-if="readyState">
    <div class="container">
      <div class="row">
        <div class="head">
          <div class="progress-container">
            <div class="label"><span>Fortschritt</span></div>
            <div class="progressBar" data-percent="40">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                <circle class="outer" cx="50" cy="50" r="40" />
                <circle class="progress" cx="50" cy="50" r="40" />
                <text class="percent" x="50" y="57">{{ Math.ceil((100 / stateMax) * qIndex) }}%</text>
              </svg>
            </div>
          </div>
          <div class="status">
            <div class="label topic" v-if="cluster">
              <span>{{ cluster }}</span>
            </div>
            <div class="question">
              <span>{{ question["text"] }}</span>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="answers">
            <div class="answer" v-for="answer in answers" :key="answer['Id']">
              <div class="radio">
                <label :for="answersType + '__qID-' + question['Id'] + '__aID-' + answer['Id']">
                  <input
                    type="radio"
                    :id="answersType + '__qID-' + question['Id'] + '__aID-' + answer['Id']"
                    :name="answersType + '__qID-' + question['Id']"
                    :value="answer['hintText']"
                    @change="getResult(answer, answersType, question['clusterid'])"
                    :checked="activeAnswer(answer)"
                  />
                  <span>{{ answer["text"] }}{{ answer["text"].slice(-1) === "." || answer["text"].slice(-1) === "!" ? "" : "." }}</span>
                </label>
              </div>
            </div>
          </div>
          <button
            class="btn btn--big next"
            @click="sendAnswers(storeResult.answer, storeResult.answersType, storeResult.question)"
            :disabled="storeResult.answer === false"
          >
            <span class="label">weiter</span>
            <span class="icon"
              ><svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18">
                <path
                  fill="currentColor"
                  d="M31,9a1.3,1.3,0,0,0-.4-1L22.8.4a1.1,1.1,0,0,0-.9-.4,1.3,1.3,0,0,0-1,.4,1.1,1.1,0,0,0-.4.9V6.6H.7l-.5.2a.8.8,0,0,0-.2.5v3.4a.8.8,0,0,0,.2.5l.5.2H20.5v5.3a1.1,1.1,0,0,0,.4.9,1.3,1.3,0,0,0,1,.4,1.1,1.1,0,0,0,.9-.4L30.6,10A1.3,1.3,0,0,0,31,9Z"
                /></svg
            ></span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Question",
  data() {
    return {
      readyState: false,
      storeResult: {
        answer: false,
        answersType: false,
        question: false,
      },
    };
  },
  props: {
    question: Object,
    answersType: String,
    answers: Array,
    sendAnswers: Function,
    randomize: Boolean,
    userSelections: Object,
    cluster: String,
    stateIs: Number,
    stateMax: Number,
    qIndex: Number,
  },
  methods: {
    getResult(a, t, q) {
      this.storeResult.answer = a;
      this.storeResult.answersType = t;
      this.storeResult.question = q;
    },
    activeAnswer(a) {
      if (this.userSelections) {
        return this.userSelections["Id"] === a["Id"];
      } else {
        return false;
      }
    },
    percentCalc(state) {
      const percent = (100 / this.stateMax) * state;
      const min = 251;
      const calc = Math.round(min - (percent * min) / 100);

      document.documentElement.style.setProperty("--percentText", JSON.stringify(Math.ceil((100 / this.stateMax) * state)));
      setTimeout(() => {
        document.documentElement.style.setProperty("--strokeDash", calc);
      }, 250);
      return calc;
    },
  },
  mounted() {
    this.percentCalc(this.qIndex);
    if (this.userSelections) {
      this.storeResult.answer = this.userSelections;
      this.storeResult.answersType = this.answersType;
      this.storeResult.question = this.question["clusterid"];
    }
    if (this.randomize) {
      // eslint-disable-next-line vue/no-mutating-props
      this.answers.sort(() => Math.random() - 0.5);
      this.readyState = true;
    } else {
      this.readyState = true;
    }
  },
};
</script>

<style scoped lang="scss"></style>
